<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.elderlyRate.ageRange1Count.$invalid 
      || $v.elderlyRate.ageRange2Count.$invalid
      || $v.elderlyRate.ageRange3Count.$invalid
      || $v.elderlyRate.ageRange4Count.$invalid
      || $v.elderlyRate.ageRange5Count.$invalid
      || $v.elderlyRate.ageRange6Count.$invalid
      || $v.elderlyRate.ageRange7Count.$invalid
      || $v.elderlyRate.achievementElderlyRate.$invalid
      || $v.elderlyRate.resultMemo.$invalid 
      || $v.elderlyRate.actionMemo.$invalid">
      <div v-if="$v.elderlyRate.ageRange1Count.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年齢構成（〜44歳）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange1Count.$invalid && !$v.elderlyRate.ageRange1Count.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange1Count.$invalid && $v.elderlyRate.ageRange1Count.numeric && !$v.elderlyRate.ageRange1Count.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.elderlyRate.ageRange2Count.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年齢構成（45〜49歳）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange2Count.$invalid && !$v.elderlyRate.ageRange2Count.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange2Count.$invalid && $v.elderlyRate.ageRange2Count.numeric && !$v.elderlyRate.ageRange2Count.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.elderlyRate.ageRange3Count.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年齢構成（50〜54歳）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange3Count.$invalid && !$v.elderlyRate.ageRange3Count.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange3Count.$invalid && $v.elderlyRate.ageRange3Count.numeric && !$v.elderlyRate.ageRange3Count.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.elderlyRate.ageRange4Count.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年齢構成（55〜59歳）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange4Count.$invalid && !$v.elderlyRate.ageRange4Count.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange4Count.$invalid && $v.elderlyRate.ageRange4Count.numeric && !$v.elderlyRate.ageRange4Count.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.elderlyRate.ageRange5Count.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年齢構成（60〜64歳）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange5Count.$invalid && !$v.elderlyRate.ageRange5Count.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange5Count.$invalid && $v.elderlyRate.ageRange5Count.numeric && !$v.elderlyRate.ageRange5Count.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.elderlyRate.ageRange6Count.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年齢構成（65〜69歳）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange6Count.$invalid && !$v.elderlyRate.ageRange6Count.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange6Count.$invalid && $v.elderlyRate.ageRange6Count.numeric && !$v.elderlyRate.ageRange6Count.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.elderlyRate.ageRange7Count.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">年齢構成（70歳〜）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange7Count.$invalid && !$v.elderlyRate.ageRange7Count.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.ageRange7Count.$invalid && $v.elderlyRate.ageRange7Count.numeric && !$v.elderlyRate.ageRange7Count.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.elderlyRate.achievementElderlyRate.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">高年齢者雇用率（実績）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.achievementElderlyRate.$invalid && !$v.elderlyRate.achievementElderlyRate.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.elderlyRate.achievementElderlyRate.$invalid && $v.elderlyRate.achievementElderlyRate.customDoubleNum && !$v.elderlyRate.achievementElderlyRate.between" validation="between" valueMin="0" valueMax="100"/>
      </div>
      <div v-if="$v.elderlyRate.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ：</span>
        <ValidationErrorMessage v-show="$v.elderlyRate.resultMemo.$invalid && !$v.elderlyRate.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.elderlyRate.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション：</span>
        <ValidationErrorMessage v-show="$v.elderlyRate.actionMemo.$invalid && !$v.elderlyRate.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">年齢構成</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col>
            <col style="width: 90px;">
            <col>
            <col style="width: 90px;">
          </colgroup>
          <tbody>
            <tr>
              <th class="u-tar">〜44歳</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.elderlyRate.$model.ageRange1Count" type="text" name="elderlyRate.ageRange1Count" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <th class="u-tar">60〜64歳</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.elderlyRate.$model.ageRange5Count" type="text" name="elderlyRate.ageRange5Count" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
            <tr>
              <th class="u-tar">45〜49歳</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.elderlyRate.$model.ageRange2Count" type="text" name="elderlyRate.ageRange2Count" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <th class="u-tar">65〜69歳</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.elderlyRate.$model.ageRange6Count" type="text" name="elderlyRate.ageRange6Count" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
            <tr>
              <th class="u-tar">50〜54歳</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.elderlyRate.$model.ageRange3Count" type="text" name="elderlyRate.ageRange3Count" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <th class="u-tar">70歳〜</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.elderlyRate.$model.ageRange7Count" type="text" name="elderlyRate.ageRange7Count" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
            <tr>
              <th class="u-tar">55〜59歳</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.elderlyRate.$model.ageRange4Count" type="text" name="elderlyRate.ageRange4Count" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__space"></div>

      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            高年齢者雇用率
            <div class="human-capitalt-data-table__input is-important has-unit">
              <TextBox v-model.trim="$v.elderlyRate.$model.achievementElderlyRate" type="text" name="elderlyRate.achievementElderlyRate" class="u-tac" @input="changeInput()"></TextBox>
              <span class="human-capitalt-data-table__unit">%</span>
            </div>
          </div>
        </div>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="elderlyRate.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(elderlyRate.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="elderlyRate.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
  },
  props: {
    // 表示年度の財務情報データ
    elderlyRate: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "名",
      unit2: "％",
    }
  },
  computed: {
    sumOfAll() {
      if ( !(this.elderlyRate.ageRange1Count!=null && this.elderlyRate.ageRange2Count!=null && this.elderlyRate.ageRange3Count!=null && this.elderlyRate.ageRange4Count!=null && this.elderlyRate.ageRange5Count!=null && this.elderlyRate.ageRange6Count!=null && this.elderlyRate.ageRange7Count!=null) ) {
        return null;
      }else if ( String(this.elderlyRate.ageRange1Count).length * String(this.elderlyRate.ageRange2Count).length * String(this.elderlyRate.ageRange3Count).length * String(this.elderlyRate.ageRange4Count).length * String(this.elderlyRate.ageRange5Count).length * String(this.elderlyRate.ageRange6Count).length * String(this.elderlyRate.ageRange7Count).length == 0 ) {
        return null;
      }else if ( isNaN(this.elderlyRate.ageRange1Count) || isNaN(this.elderlyRate.ageRange2Count) || isNaN(this.elderlyRate.ageRange3Count) || isNaN(this.elderlyRate.ageRange4Count) || isNaN(this.elderlyRate.ageRange5Count) || isNaN(this.elderlyRate.ageRange6Count) || isNaN(this.elderlyRate.ageRange7Count)) {
        return null;
      }else{
        return Number(this.elderlyRate.ageRange1Count) + Number(this.elderlyRate.ageRange2Count) + Number(this.elderlyRate.ageRange3Count) + Number(this.elderlyRate.ageRange4Count) + Number(this.elderlyRate.ageRange5Count) + Number(this.elderlyRate.ageRange6Count) + Number(this.elderlyRate.ageRange7Count);
      }
    },
    sumOfElderly() {
      if ( !( this.elderlyRate.ageRange4Count!=null && this.elderlyRate.ageRange5Count!=null && this.elderlyRate.ageRange6Count!=null && this.elderlyRate.ageRange7Count!=null ) ) {
        return null;
      }else if ( String(this.elderlyRate.ageRange4Count).length * String(this.elderlyRate.ageRange5Count).length * String(this.elderlyRate.ageRange6Count).length * String(this.elderlyRate.ageRange7Count).length == 0 ) {
        return null;
      }else if ( isNaN(this.elderlyRate.ageRange4Count) || isNaN(this.elderlyRate.ageRange5Count) || isNaN(this.elderlyRate.ageRange6Count) || isNaN(this.elderlyRate.ageRange7Count)) {
        return null;
      }else{
        return Number(this.elderlyRate.ageRange4Count) + Number(this.elderlyRate.ageRange5Count) + Number(this.elderlyRate.ageRange6Count) + Number(this.elderlyRate.ageRange7Count);
      }
    },
/*    calAchievementElderlyRate() {
      if ( this.sumOfAll != null && this.sumOfElderly != null ){
        if(this.sumOfAll == 0) return null;
        if(this.sumOfElderly == 0) return 0;
        let val = (this.sumOfElderly / this.sumOfAll) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }else{
        return null;
      }
    }*/
  },
  validations: {
    elderlyRate: {
      ageRange1Count : { numeric, between: between(0,99999) },         // 年齢構成（〜44歳）
      ageRange2Count : { numeric, between: between(0,99999) },         // 年齢構成（45〜49歳）
      ageRange3Count : { numeric, between: between(0,99999) },         // 年齢構成（50〜54歳）
      ageRange4Count : { numeric, between: between(0,99999) },         // 年齢構成（55〜59歳）
      ageRange5Count : { numeric, between: between(0,99999) },         // 年齢構成（60〜64歳）
      ageRange6Count : { numeric, between: between(0,99999) },         // 年齢構成（65〜69歳）
      ageRange7Count : { numeric, between: between(0,99999) },         // 年齢構成（65歳〜）
      achievementElderlyRate : { 
        between: between(0,100), 
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,3}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    elderlyRate() {
      this.inputElderlyRate();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputElderlyRate() {
      this.$emit("change-elderly-rate", {
        elderlyRate: this.elderlyRate,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
